import * as $http from 'axios'

export default {
    post: payload => $http.post('v2/inquiries', payload),
    updateFunnel: payload => $http.put('v2/inquiries/update_funnel', payload),
}
